import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

export function Timeout(): JSX.Element {
	return (
		<div
			className="bg-background-base p-12"
			data-qa="social-media-content-container"
			data-testid="social-media-content-timeout-container"
		>
			<Text as="p" className="text-typography-strong">
				<Translate value="corgi.petition.starter_dashboard_v2.shared.share_visuals.modal_timeout" />
			</Text>
		</div>
	);
}
